import React, { useState } from 'react';
import EarlyAccessBtn from '../../baseComponents/EarlyAccessBtn';
import './BlogCTA.css';

const BlogCTA = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (event) => {
    event.preventDefault();
    if (!email.trim()) {
      alert('Please enter your email address');
      return;
    }
    alert('Thanks for subscribing!');
    setEmail('');
  };

  return (
    <section className="blog-cta">
      <div className="page-container">
        <div className="blog-cta-grid">
          <div className="blog-cta-card blog-cta-access">
            <h3>Ready to get started? Reserve your spot now.</h3>
            <p>We&apos;re launching soon! Sign up to be the first to experience our web application.</p>
            <EarlyAccessBtn padding=".7em 1.4em" />
          </div>

          <div className="blog-cta-card blog-cta-newsletter">
            <p className="blog-cta-eyebrow">
              Stay updated with recent news, articles, or valuable materials.
            </p>
            <h3>Sonaroid Insights: Straight to your inbox.</h3>
            <form className="blog-cta-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-label="Email address"
              />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogCTA;
